import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { InternalLearnerService } from '../../features/collaborateur/services/internal-learner.service';
import { AuthService } from './auth.service';

export const internalLearnerGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const internalLearner = inject(InternalLearnerService);
  const router = inject(Router);

  if (internalLearner.hasAccess()) {
    return true;
  }

  return internalLearner.refresh().pipe(
    map((hasAccess) => (hasAccess ? true : router.parseUrl(auth.homePathForCurrentUser())))
  );
};
